
import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import "./App.css";
import "./index.css";

import FooterBasic from "./components/Footer";
import Navigation from "./components/NavBar";
import Main from "./components/Main";
import Agents from "./components/Agents";
import AgentInfo from "./components/AgentInfo";
import Services from "./components/Services";
import ContactForm from "./components/Contacts";
import NewOrder from "./components/Order";
import QuestionnaireComponent from "./components/QuestionnaireComponent";
import TermsAndConditions from "./components/TermsAndConditions";
import CartPage from "./components/CardPage";
import ThankYou from "./components/ThankYou";
import B2BFullPageSolarHero from "./components/B2B";
import InventoryDashboard from "./components/InventoryDashboard";
import ProtectedRoute from "./components/protectedRoute";
import Login from "./components/Login";


function App() {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <div className="App">
      <Navigation />

      <main
        className={
          isHomePage
            ? "page-content home-page"
            : "page-content"
        }
      >
        <Routes>
          <Route path="/" element={<Main />} />

          <Route path="/contacts" element={<ContactForm />} />

          <Route
            path="/preparati-za-solarni-paneli"
            element={<Agents />}
          />

          <Route path="/agentInfo/:abb" element={<AgentInfo />} />

          <Route
            path="/uslugi-solarni-paneli"
            element={<Services />}
          />

          <Route
            path="/porachka-na-preparati-za-solarni-paneli"
            element={<NewOrder />}
          />

          <Route
            path="/oferta-na-preparati-za-solarni-paneli"
            element={<QuestionnaireComponent />}
          />

          <Route path="/terms" element={<TermsAndConditions />} />

          <Route path="/thank-you" element={<ThankYou />} />

          <Route path="/cart" element={<CartPage />} />

          <Route path="/b2b" element={<B2BFullPageSolarHero />} />

          <Route path="/login" element={<Login />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <InventoryDashboard />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Login />} />
        </Routes>
      </main>

      <FooterBasic />
    </div>
  );
}

export default App;
